import { registry } from '@cian/mf-registry/browser';

import { ISearchStringAPI, ISearchStringResult } from 'shared/types/searchString';

const searchStringApiCall = async <Params, Result = ISearchStringResult>(
  path: string,
  params: Params,
): Promise<Result> => {
  const api = await registry().microfrontendStrict('search-string-micro-frontend').api()?.ensure();

  return api?.call(path, params) as Result;
};

export const getSearchStringMicrofrontendAPI = (): ISearchStringAPI => {
  return {
    setFilterJsonQuery: (jsonQuery: object) => {
      return searchStringApiCall<{ jsonQuery: object }, void>('/v1/set-filter-json-query', { jsonQuery });
    },
  };
};
